// src/components/rpa/agent/AgentResultCard.js
import React from 'react';
import './AgentResultCard.css';

const AgentResultCard = ({ plan, summary, nextStep }) => {
  const isComplete = nextStep?.status === 'complete';

  return (
    <div className="agent-result-card">
      <div className="result-header">
        <span className="result-icon">✅</span>
        <span className="result-title">Step Completed</span>
      </div>

      <div className="result-body">
        <div className="result-row">
          <span className="result-label">Step</span>
          <span className="result-value step-badge-green">
            {plan.stepTitle || plan.stepId}
          </span>
        </div>
        <div className="result-row">
          <span className="result-label">Action</span>
          <span className="result-value">{plan.description}</span>
        </div>
      </div>

      {summary && (
        <div className="result-summary">
          <span className="result-summary-label">Summary</span>
          <p className="result-summary-text">{summary}</p>
        </div>
      )}

      <div className={`result-next ${isComplete ? 'complete' : ''}`}>
        {isComplete ? (
          <>
            <span className="next-icon">🎉</span>
            <span className="next-text">All workflow steps are complete for this document.</span>
          </>
        ) : (
          <>
            <span className="next-icon">→</span>
            <span className="next-text">
              Next pending step: <strong>{nextStep?.stepTitle || nextStep?.stepId}</strong>
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default AgentResultCard;